import { GcpBox, GcpTypography, getDatetimeText } from '@back-office/ui';
import { Button } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface TransactionVoidProps {
  id: string;
  showCancelBtn: boolean;
  showRequestBtn: boolean;
  showVoidBtn: boolean;
  transactionID: string;
  updatedAt: string;
  updatedBy: string | null;
  onCancelClick: () => void;
  onRequestClick: () => void;
  onVoidClick: () => void;
}

const TransactionVoid: FC<TransactionVoidProps> = (props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('lg'));
  const {
    id,
    showCancelBtn,
    showRequestBtn,
    showVoidBtn,
    transactionID,
    updatedAt,
    updatedBy,
    onCancelClick,
    onRequestClick,
    onVoidClick,
  } = props;

  return (
    <GcpBox display="flex" mt={2}>
      <Grid xs={9}>
        <GcpTypography variant="h2">{transactionID || '-'}</GcpTypography>
        <GcpTypography paint="hitGray" variant="body1">
          {id}
          {!matches && <br />}
          &nbsp;&bull;&nbsp;
          {t('transaction_list.updated', {
            date: updatedAt ? getDatetimeText(updatedAt, 'default') : '-',
            editor: updatedBy || '-',
          })}
        </GcpTypography>
      </Grid>
      <Grid xs={3}>
        <GcpBox display="flex" justifyContent="flex-end" pt={2}>
          {showVoidBtn && (
            <Button color="primary" variant="contained" onClick={onVoidClick}>
              {t('dialog.void')}
            </Button>
          )}
          {showCancelBtn && (
            <Button color="primary" variant="contained" onClick={onCancelClick}>
              {t('request_refund.cancel_refund_btn')}
            </Button>
          )}
          {showRequestBtn && (
            <Button
              color="primary"
              variant="contained"
              onClick={onRequestClick}
            >
              {t('request_refund.request_refund_btn')}
            </Button>
          )}
        </GcpBox>
      </Grid>
    </GcpBox>
  );
};

export default TransactionVoid;
